module.exports = __webpack_public_path__ + "static/img/3.7f39a770.png";